$('.realizationsFeed').slick({
  slidesToShow: 3,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: false,
 arrows: true,
 infinite: false,
 variableWidth: true,
 responsive: [
   {
     breakpoint: 991,
     settings: {
       slidesToShow: 2,
       slidesToScroll: 1,
       arrows: false,
       dots: true,
       variableWidth: false,
     }
    
   }
 ]
});